export default "/assets/images/life-saving-co-sensor-thumbnail.jpg?8057c532e8fa8bcad8afb56c82f7e57b";